// extracted by mini-css-extract-plugin
export default {"container":"ExerciseContainer_container__PsDbv","content":"ExerciseContainer_content__t+CVe","navContainer":"ExerciseContainer_navContainer__zQhHx"};